import { useLanguage } from '../contexts/LanguageContext';

export function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="py-12 text-white bg-gradient-to-b from-primary-600 to-primary-700">
      <div className="px-6 max-w-7xl mx-auto text-center">
        <div className="flex items-center justify-center space-x-2 mb-4">
          <img 
            src="/NestQ_logo_White.png" 
            alt="NestQ" 
            className="w-30 rounded-lg"
          />
        </div>
        <p className="text-sm mb-4">{t.landingPage.footerTagline}</p>
        <div className="border-t pt-8 text-center text-sm border-white/20">
          <p>{t.landingPage.copyright}</p>
          <p className="mt-1 text-xs opacity-75">version 0.4.23</p>
        </div>
      </div>
    </footer>
  );
}
